import React from 'react';

import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { Link, withRouter } from 'react-router-dom';

import SafelyRenderHtml from '@src/services/renderEditorText';

import { Agent360Keyword } from '@src/components/global/agent360Keyword';
import { ArsKeyword } from '@src/components/global/arsKeyword';
import { logOut } from '@src/components/helpers';

import Item from './MobileHeaderMenuItem';

class MobileHeaderMenu extends React.PureComponent {
    static propTypes = {
        menus: PropTypes.arrayOf(PropTypes.object).isRequired,
        match: PropTypes.shape({
            url: PropTypes.string.isRequired,
        }),
        location: PropTypes.object,
    };

    static getDerivedStateFromProps(props, state) {
        const { location: { pathname } } = props;

        if (state.pathname === pathname) {
            return null;
        }

        return {
            pathname,
            chevronToggleActive: false,
            activeEventKey: null,
        };
    }

    constructor(props) {
        super(props);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            pathname: props.location.pathname,
            chevronToggleActive: false,
            activeEventKey: null,
        };
    }

    isItemActive = (itemId) => {
        const {
            chevronToggleActive,
            activeEventKey,
        } = this.state;

        return chevronToggleActive && activeEventKey === itemId;
    };

    handleOnItemClick = (itemId) => {
        this.setState((state) => {
            if (state.activeEventKey === itemId) {
                return {
                    activeEventKey: null,
                    chevronToggleActive: false,
                };
            }

            return {
                chevronToggleActive: true,
                activeEventKey: itemId,
            };
        });
    };

    handleLogout = () => {
        logOut();
    };

    renderLink = (link) => {
        if (link.url.search(/^https?:\/\//) !== -1 || link.url.includes('/ask-foremost')) {
            return (
                <li key={`panel-li-${link.url}`}>
                    <a
                        href={link.url}
                        className="external-link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {SafelyRenderHtml(link.displayName)}
                    </a>
                </li>
            );
        }

        return (
            <li key={`panel-li-${link.url}`}>
                <Link to={link.url}>
                    { SafelyRenderHtml(link.displayName) }
                    { link.platform === 'agent360' && <Agent360Keyword />}
                    { link.platform !== 'agent360' && <ArsKeyword title={link.displayName} />}
                </Link>
            </li>
        );
    };

    renderPanel = (panel) => {
        const { title, description, listOfLinks } = panel;

        return (
            <React.Fragment key={title}>
                <h1>{ SafelyRenderHtml(title) }</h1>
                {description && <p>{SafelyRenderHtml(description)}</p>}
                <ul>
                    {listOfLinks && listOfLinks.map(this.renderLink)}
                </ul>
            </React.Fragment>
        );
    };

    renderMenuItem = (menuItem) => {
        const target = menuItem.id === 'essential_links' ? '_blank' : '_self';

        if (menuItem.panels) {
            return (
                <Item
                    key={menuItem.id}
                    itemId={menuItem.id}
                    isActive={this.isItemActive(menuItem.id)}
                    displayName={menuItem.displayName}
                    onClick={this.handleOnItemClick}
                >
                    { menuItem.panels.map(this.renderPanel) }
                </Item>
            );
        }

        if (menuItem.id === 'logout') {
            return (
                <Card key={menuItem.id} className="border-left-0 border-right-0 rounded-0">
                    <Accordion.Toggle as={Card.Header} variant="link" eventKey={menuItem.id}>
                        <Link to="/" onClick={this.handleLogout}>{menuItem.displayName}</Link>
                    </Accordion.Toggle>
                </Card>
            );
        }

        return (
            <Card key={menuItem.id} className="border-left-0 border-right-0 rounded-0">
                <Accordion.Toggle as={Card.Header} variant="link" eventKey={menuItem.id}>
                    <Link to={{ pathname: menuItem.url }} target={target}>{menuItem.displayName}</Link>
                </Accordion.Toggle>
            </Card>
        );
    };

    renderMenuItems = () => {
        const { menus } = this.props;

        return menus.map((menu) => this.renderMenuItem(menu));
    };

    render() {
        return (
            <Accordion className="w-100" activeKey={this.state.activeEventKey}>
                { this.renderMenuItems() }
            </Accordion>
        );
    }
}

export default withRouter(MobileHeaderMenu);
